'use client'

import { AppWrapper } from '~/components/app-wrapper'
import { MyEventsPage } from '~/domains/events/components/my-events/page'

export const Page = () => (
	<AppWrapper className='max-md:pb-[60px]'>
		<MyEventsPage />
	</AppWrapper>
)
